export const dirtyTracker = {

  namespaced: true,

  // add new states as needed, everything else will just work
  state: {
    scorecard: false,
    task: false,
  },

  getters: {
    isDirty: (state) => (key) => state[key],
    anyDirty: (state) => state.scorecard || state.task,
  },

  mutations: {
    SET_DIRTY(state, { key, value }) {
      state[key] = value
    },
    CLEAR_ALL(state) {
      Object.keys(state).forEach(key => {
        state[key] = false
      })
    },
  },

  actions: {
    setDirty({ commit }, {key, value} ) {
      commit("SET_DIRTY", {key, value} )
    },
    clearAll({ commit }, ) {
      commit("CLEAR_ALL")
    },
  },

}
